{{'iackathon.format' | translate}}: {{format()}}

<a>{{label()}}</a>
